<template>
    <div>
        <div class="datatable-container">
            <CCard class="shadow-sm">
                <CCardBody>
                    <CRow>
                        <CIcon size="2xl" name="cil-basket" class="text-success col-2 col-sm-1 col-lg-1" />
                        <CCol col="7" sm="9" md="9" lg="9">
                            <select class="custom-select text-dark" v-model="selectedShop" id="shop-select">
                                <option selected>{{ $t('selectshop') }}</option>
                                <option v-for="shop in shops" :key="shop.objectId" :value="shop.objectId">
                                    {{ shop.shopName }} - {{ shop.branchName }}
                                </option>
                            </select>
                        </CCol>
                        <div class="col-3 col-sm-2 col-md-2 text-right">
                        <CButton block v-on:click="getInfo()" color="success">
                            {{ $t('submit') }}
                            </CButton>
                        </div>
                    </CRow>
                </CCardBody>
            </CCard>
            <div  v-if="isPermission">
                <CCard>
                    <CCardBody>
                        <div class="mb-2 text-center">
                            <h2 class="font-weight-normal text-center">
                                {{ $t("translateProduct") }} 
                            </h2>
                            <!-- <p class="m-0">{{ $t('แปลชื่อเมนูได้ไวด้วย AI') }} <img src="/img/languages/Ai_G.png"
                                    style="width: 20px; height: 20px;" /></p>
                            <p class="m-0">{{ $t('แค่คลิกเดียว AI จะช่วยแปลชื่อเมนูของคุณไปยังหลายภาษาอัตโนมัติ ง่าย เร็วและแม่นยำ 🎯') }}</p> -->
                        </div>
                        <hr />
                        <CAlert color="info" class="d-inline-block col-12 mt-0 mb-1 ">
                            <div class="d-flex">
                                <div class="flex-shrink-0">
                                    <i class="fi fi-rr-info mr-1 text-warning"></i>
                                </div>
                                <div class="flex-grow-1 ms-3 ml-2">
                                    <p class="mb-1 text-dark font-weight-bold">{{ $t('translateHowToTitle') }}</p>
                                    <p class="mb-0 text-muted" v-html="$t('translateStep1')"></p>
                                    <p class="mb-0 text-muted" v-html="$t('translateStep2')"></p>
                                    <p class="mb-0 text-muted">{{ $t('translateStep3') }}</p>
                                    <p class="mb-0 text-muted" v-html="$t('translateStep4')"></p>
                                    <p class="mb-0 text-muted"><i class="fi fi-rr-bulb mr-1 text-warning"></i> <b>{{ $t('translateNote') }}</b></p>
                                </div>
                            </div>
                        </CAlert>
                        <!-- Tab Navigation -->

                        <NavTabs :value="currentTab" :tabs="tabList" @input="onTabChange" class="mt-2" />

                        <div class="">
                            <div v-if="currentTab === 'product'">
                                <product ref="productTab"></product>
                            </div>
                            <div v-if="currentTab === 'category'">
                            <category ref="categoryTab"></category>
                            </div>
                            <div v-if="currentTab === 'option'">
                            <Option ref="optionTab"></Option>
                            </div>
                            <div v-if="currentTab === 'optionGroup'">
                                <OptionGroup ref="optionGroupTab"></OptionGroup>
                            </div>
                        </div>
                    </CCardBody>
                </CCard>
            </div>
            <div v-else>
                <access-data></access-data>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import NavTabs from '@/containers/NavTabs.vue';
import pos from "@/services/local";
import permis from "@/util/permission";
import Product from "@/views/product/Translation/Product.vue";
import Category from "@/views/product/Translation/Category.vue";
import Option from "@/views/product/Translation/Option.vue";
import OptionGroup from "@/views/product/Translation/OptionGroup.vue";

export default {
    data() {
        return {
            selectedLanguage: 'en',
            selectedShop: this.$store.getters.shopObjectId,
            showDescription: false,
            languages: [
                { value: 'th', name: 'ไทย', img: '/img/languages/flag_TH01.png' },
                { value: 'en', name: 'English', img: '/img/languages/flag_EN01.png' },
                { value: 'lo', name: 'ລາວ', img: '/img/languages/flag_LA01.png' },
                { value: 'my', name: 'မြန်မာ', img: '/img/languages/flag_MM01.png' },
                { value: 'zh', name: 'Chinese', img: '/img/languages/flag_China01.png' },
                { value: 'ja', name: '日本語', img: '/img/languages/flag_JP01.png' },
                { value: 'km', name: 'ភាសាខ្មែរ', img: '/img/languages/flag_Cambodia01.png' },
                { value: 'ko', name: '한국어', img: '/img/languages/ko.png' },
                { value: 'hi', name: 'हिन्दी', img: '/img/languages/flag_India01.png' },
                { value: 'id', name: 'Bahasa Indonesia', img: '/img/languages/flag_Indo01.png' },
                { value: 'ar', name: 'العربية', img: '/img/languages/flag_Arab01.png' }
            ],
            data: [
                { SKUName: 'อเมริกาโน่', description: 'Strong coffee', nameTranslation: { en: 'Americano', th: 'อเมริกาโน่', fr: 'Américain' }, descriptionTranslation: { en: 'Strong coffee', th: 'กาแฟเข้ม', fr: 'Café fort' } },
                { SKUName: 'วานิลลา', description: 'Sweet flavor', nameTranslation: { en: 'Vanilla', th: 'วานิลลา', fr: 'Vanille' }, descriptionTranslation: { en: 'Sweet flavor', th: 'รสหวาน', fr: 'Saveur douce' } },
                { SKUName: 'ช็อคโกแลต', description: 'Chocolate flavor', nameTranslation: { en: 'Choco', th: 'ช็อคโกแลต', fr: 'Chocolat' }, descriptionTranslation: { en: 'Chocolate flavor', th: 'รสช็อคโกแลต', fr: 'Saveur chocolat' } }
            ],
            selectedItems: [],
            currentTab: 'product',
            tabList: [
                { name: 'product', label: this.$i18n.t('product') },
                { name: 'category', label: this.$i18n.t('category') },
                { name: 'option', label: this.$i18n.t('optional') },
                { name: 'optionGroup', label: this.$i18n.t('txtOptionCategory') },
            ],
            translateBy : 'name',
            sort_value: {
                name: "SKUName",
                updated_at: "updated_at",
                category: "category.name"
            },
            sortdata: this.$route.query.sort || "SKUName",

        };
    },
    components: {
        NavTabs,
        Product,
        Category,
        Option,
        OptionGroup
    },
    computed: {
        ...mapGetters(["shops", "users", "date"]),
        shopObjectId: {
            get() {
                return this.$store.getters.shopObjectId;
            },
            set(newValue) {
                return this.$store.dispatch("setShop", newValue);
            }
        },
        isPermission() {
            return permis.findPermissionRead("product", this.$route.path);
        },
    },
    watch: {
        shopObjectId() {
            // เช็ค permission ใหม่ทุกครั้งที่เปลี่ยนสาขา
            this.selectedShop = this.$store.getters.shopObjectId
            this.$nextTick(() => {
                this.getInfo()
            })
        },
        
    },

    created() {
        this.shop = this.shops.find((i) => this.shopObjectId === i.objectId);
    },
    methods: {

        getInfo() {
            // Dispatch shopObjectId to store เมื่อกดตกลงเท่านั้น
            this.$store.dispatch("setShop", this.selectedShop)
            this.$store.dispatch("getPermission")

            const refMap = {
                product: 'productTab',
                category: 'categoryTab',
                option: 'optionTab',
                optionGroup: 'optionGroupTab'
            }
            const currentRef = this.$refs[refMap[this.currentTab]]
            if (currentRef) {
                if (currentRef.updateList) {
                    if (currentRef.updateList.length > 0) {
                        const confirmed = window.confirm(
                            `มีรายการที่แก้ไขค้างอยู่ ${currentRef.updateList.length} รายการ ยังไม่ได้บันทึก\nต้องการโหลดข้อมูลใหม่หรือไม่? (ข้อมูลที่แก้ไขจะหายไป)`
                        )
                        if (!confirmed) {
                            return
                        }
                    }
                    currentRef.updateList = []
                }
                if (this.currentTab === 'product') {
                    currentRef.getProduct()
                    if (currentRef.getCategory) currentRef.getCategory()
                } else if (this.currentTab === 'category') {
                    currentRef.getProductCategory()
                } else if (this.currentTab === 'option') {
                    currentRef.getProductOption()
                } else if (this.currentTab === 'optionGroup') {
                    currentRef.getProductOptionGroup()
                }
            }
        },

        onTabChange(newTab) {
            // ตรวจสอบว่า tab ปัจจุบันมีรายการที่ยังไม่บันทึกหรือไม่
            const refMap = {
                product: 'productTab',
                category: 'categoryTab',
                option: 'optionTab',
                optionGroup: 'optionGroupTab'
            }
            const currentRef = this.$refs[refMap[this.currentTab]]
            const hasUnsaved = currentRef && currentRef.updateList && currentRef.updateList.length > 0

            if (hasUnsaved) {
                const confirmed = window.confirm(`มีรายการที่ยังไม่ได้บันทึก ${currentRef.updateList.length} รายการ\nต้องการออกจากหน้านี้โดยไม่บันทึกหรือไม่?`)
                if (!confirmed) {
                    return // อยู่ tab เดิม
                }
            }
            this.currentTab = newTab
        },

        getFlagIcon(language) {
            const lang = this.languages.find(lang => lang.value === language);
            return lang ? lang.img : '';
        },
        goback() {
            // Go back logic
        },

    }
};
</script>

<style >
.lang-icon {
    align-items: unset;
    width: 32px;
    height: auto;
}

/* Your custom styles here */
</style>
<style src="../../../src/assets/styles/sortCss.css"></style>